/*eslint-disable*/ export const messages = JSON.parse("{\"breadcrumbs.ariaLabel\":[\"You are here\"]}");
//# sourceMappingURL=messages.mjs.map